import { SET_SELECTED_MEMBERSHIP_TYPE, SET_HIDE_ACTION_REQUIRED } from '@/store/mutationTypes'
import { membershipType, membership } from '@/api'
import { handleError, prepareResponse, requestFinished } from '@/store/utils'
import {skipWelcomeEmail} from "../utils";


export default {
  actions: {
    hideActionsRequired({commit}) {
      commit(SET_HIDE_ACTION_REQUIRED, true)
    },
    listMembershipTypes({commit, getters}, {inviteCodes}) {
      prepareResponse(commit)
      return membershipType.list(inviteCodes, getters.userToken)
        .then((response) => {
          requestFinished(commit)
          return Promise.resolve(response.membershipTypes.data)
        }, (err) => {
          handleError(commit, err)
          return Promise.reject(err)
        })
        .catch(err => {
          handleError(commit, err)
          return Promise.reject(err)
        })
    },

    getMembershipType({dispatch, getters}, {id, inviteCodes}) {
      return membershipType.get(id, inviteCodes, getters.userToken)
        .then((response) => {
          dispatch('selectMembershipType', response.membershipType)
        })
    },

    selectMembershipType({commit, dispatch}, type) {
      commit(SET_SELECTED_MEMBERSHIP_TYPE, type)
      dispatch('removeMembershipCoupon')
    },

    acceptUpgrade({commit, dispatch, getters}, params) {
      prepareResponse(commit)
      return membership.acceptUpgrade(params, getters.userToken)
        .then((response) => {
          requestFinished(commit)
          dispatch('loadCurrentUser')
          return Promise.resolve(response.updateMembership)
        },
        err => {
          handleError(commit, err)
          return Promise.reject(err)
        })
        .catch(err => {
          handleError(commit, err)
          return Promise.reject(err)
        })
    },

    updateMembership({commit, dispatch, getters}, params) {
      prepareResponse(commit)
      return membership.update(params, getters.userToken)
        .then((response) => {
          requestFinished(commit)
          if (params && params.membershipTypeId!=null) {
            // membership upgraded.. record a new membership scan
            dispatch('recordMembershipScan');
          }
          dispatch("removePresetMembershipCouponCode")
          dispatch('loadCurrentUser')
          return Promise.resolve(response.updateMembership)
        },
        err => {
          return handleError(commit, err)
        })
        .catch(err => {
          return handleError(commit, err)
        })
    },

    cancelMembership({commit, dispatch, getters}, params) {
      prepareResponse(commit)
      return membership.cancel(params, getters.userToken)
        .then((response) => {
            requestFinished(commit)
            dispatch('loadCurrentUser')
            return Promise.resolve(response.updateMembership)
          },
          err => {
            handleError(commit, err)
            return Promise.reject(err)
          })
        .catch(err => {
          handleError(commit, err)
          return Promise.reject(err)
        })
    },

    createMembership({commit, dispatch, getters}, params) {
      prepareResponse(commit)
      return membership.create(params, getters.userToken)
        .then((response) => {
          requestFinished(commit)
          dispatch('recordMembershipScan');
          dispatch("removePresetMembershipCouponCode")
          dispatch('loadCurrentUser')
          if (!skipWelcomeEmail(response.createMembership)) {
            // disable before switching  to HubSpot_Mailer
            // dispatch('sendWelcomeEmail')
          }
          return Promise.resolve(response.createMembership)
        },
        err => {
          return handleError(commit, err)
        })
        .catch(err => {
          return handleError(commit, err)
        })
    },

    completeMembership({commit, dispatch, getters}, params) {
      prepareResponse(commit)
      return membership.complete(params, getters.userToken)
        .then((response) => {
          requestFinished(commit)
          dispatch('recordMembershipScan');
          dispatch("removePresetMembershipCouponCode")
          dispatch('loadCurrentUser')
          if (!skipWelcomeEmail(response.completeMembership)) {
            // disable before switching  to HubSpot_Mailer
            // dispatch('sendWelcomeEmail')
          }
          return Promise.resolve(response.completeMembership)
        },
        err => {
          handleError(commit, err)
          return Promise.reject(err)
        })
        .catch(err => {
          handleError(commit, err)
          return Promise.reject(err)
        })
    },

    getMembershipPayments({commit, getters}) {
      prepareResponse(commit)
      return membership.getPayments(getters.currentUser.membership.id, getters.userToken)
        .then(response => {
          requestFinished(commit)
          return Promise.resolve(response.membership)
        },
        err => {
          handleError(commit, err)
          return Promise.reject(err)
        })
        .catch(err => {
          handleError(commit, err)
          return Promise.reject(err)
        })
    }
  }
}
